import React, {Suspense} from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import IndusriesIndex from '../../pages/admin/industries/IndustriesIndex';

function Zones(props) {
  const { path } = useRouteMatch();
  const { t } = useTranslation();

	return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={`${path}`} component={IndusriesIndex}/>
      </Switch>
    </Suspense>
	)
}

export default Zones
